<template>
  <my-modal>
    <div>
      <h2 class="form__title">{{ deletionDate ? 'Восстановление анкеты' : 'Удаление анкеты'}}</h2>
      <template v-if="!deletionConfirm && !deletionRecall">
        <div class="form__description form__description_align-center">
          Удаление персональных данных&nbsp;&mdash; это необратимая операция.
          <br><br>
          После удаления персональные данные не&nbsp;могут быть восстановлены.
          <br><br>
          <span v-if="deletionDate">Ваша анкета будет удалена {{deletionDate | dateFilter}}</span>
          <span v-else>Ваши данные будут удалены автоматически через 30&nbsp;дней после Вашего подтверждения</span>
        </div>
        <div class="form-row form-row_align-center form-row_mobile-wrap">
          <button class="form__submit button button__lg button__blue" type="submit" @click.prevent="send">{{deletionDate ? 'Восстановить' : 'Удалить'}}</button>
        </div>
        <div class="form-row form-row_align-center">
          <router-link :to="{ path: '/cabinet' }" class="form__link">Назад</router-link>
        </div>
      </template>
      <template v-if="deletionConfirm">
        <div class="form__description form__description_align-center">
          Вы точно хотите удалить анкету?
        </div>
        <div class="form__description form__description_align-center">
          <a href="#" class="form__link" @click.prevent="deletionApply">Удалить анкету</a>
        </div>
        <div class="form__description_align-center">
          <router-link :to="{ path: '/cabinet' }" class="button button__blue button__lg">Назад</router-link>
        </div>
      </template>
      <template v-if="deletionRecall">
        <div class="form__description form__description_align-center">
          Ваша анкета успешно восстановлена
        </div>
        <div class="form__description_align-center">
          <router-link :to="{ path: '/cabinet' }" class="button button__blue button__lg">Назад</router-link>
        </div>
      </template>
    </div>
  </my-modal>
</template>

<script>
  export default {
    name: "ProfileDelete",
    data() {
      return {
        deletionConfirm: false,
        deletionStatus: false,
        deletionRecall: false
      }
    },
    computed: {
      deletionDate() {
        return this.$store.getters.deletionDate
      }
    },
    methods: {
      async deletionApply() {
        await this.$store.dispatch("deleteProfile");
        this.deletionConfirm = false;
      },
      async send() {
        if (this.deletionDate) {
          await this.$store.dispatch("deletionRecall");
          this.deletionRecall = true;
        } else {
          this.deletionConfirm = true;
        }
      }
    }
  }
</script>
